import { environment } from '../../../../../environments/environment';

const userPath = '/user/myInfo';
const myAccessPath = '/user/myAccess';
const loginjwtPath = '/user/loginByJwt';
const loginbytokenPath = '/user/loginByToken';
const logoutjwtPath = '/user/logout';


export const LoginJWTServicePathConst = `${environment.api.baseUrl}${loginjwtPath}`;
export const LogoutJWTServicePathConst = `${environment.api.baseUrl}${logoutjwtPath}`;
export const RedirectLoginServicePathConst = `${environment.api.apiV1}${userPath}`;
export const RoleMyAccessServicePathConst = `${environment.api.apiV1}${myAccessPath}`;

export const LoginBytokenServicePathConst = `${environment.api.apiV1}${loginbytokenPath}`;

